// src/context/ProductContext.js
import React, { createContext, useContext, useState } from "react";
import axios from "axios";

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);

  // Fetch products from API
  const fetchProducts = async () => {
    try {
      const res = await axios.get("http://localhost:5001/api/FetchProductListAPI");
      setProducts(res.data);
    } catch (err) {
      console.error("Product API Error:", err);
    }
  };

  return (
    <ProductContext.Provider value={{ products, fetchProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

// Custom hook to access context
export const useProducts = () => useContext(ProductContext);
